import "./blocked.scss";
import { FunctionComponent, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { fetchBlockedList } from "../../../store/UserSlice";

import { DataList, DataListColumn, StatusBadge } from "../../../components/ui";

const Blocked: FunctionComponent = () => {

    const dispatch = useAppDispatch();
    const blocked  = useAppSelector((state) => state.user.blockedList);

    useEffect(() => { dispatch(fetchBlockedList()); }, [dispatch]);

    const columns: DataListColumn<any>[] = [
        { key: "name",   header: "Nome",   render: (u) => u.name },
        { key: "email",  header: "Email",  render: (u) => <span style={{ opacity: .55 }}>{u.email}</span> },
        { key: "login",  header: "Login",  render: (u) => <span style={{ opacity: .55 }}>{u.login}</span> },
        { key: "status", header: "Status", render: (u) => <StatusBadge status={u.status} tone="danger" /> },
    ];

    return (
        <div className="blocked-wrapper">
            <h1 className="page-title">
                Usuarios Bloqueados
                <small>lista de usuarios bloqueados da organizacao.</small>
            </h1>

            <DataList
                columns={columns}
                rows={blocked ?? []}
                loading={!blocked}
                empty="Nenhum usuario bloqueado."
            />
        </div>
    );
};

export default Blocked;
